import React from 'react';
import { ReactComponent as CheckIcon } from 'assets/icons/checkIcon.svg';
import { ReactComponent as ElipsisIcon } from 'assets/icons/ellipseIcon.svg';
import {
    StepItemContainer,
    StepIconCircle,
    StepLabel,
    StepLinkWrapper,
} from './formStepper.styled';

type StepItemProps = {
    label: string;
    status: 'done' | 'current' | 'upcoming';
    isActive: boolean;
    onClick?: () => void;
    isClickable?: boolean;
};

export default function StepItem({
    label,
    status,
    onClick,
    isActive,
    isClickable = true,
}: StepItemProps) {
    const content = (
        <StepItemContainer status={status} active={isActive} disabled={!isClickable}>
            <StepLabel status={status} disabled={!isClickable}>
                {label}
            </StepLabel>

            <StepIconCircle status={status}>
                {status === 'upcoming' ? <ElipsisIcon /> : <CheckIcon />}
            </StepIconCircle>
        </StepItemContainer>
    );

    return (
        <StepLinkWrapper onClick={onClick} disabled={!isClickable}>
            {content}
        </StepLinkWrapper>
    );
}
